import React, { Component } from 'react';
import {Link} from 'react-router-dom';

export class NewsItem extends Component {
    state = {  }
    render() { 
        return ( 
            <div className="card border-white">
                <div className="card-body">
                    <h5 class="card-title heading" style={{color: '#EE3124'}}>{this.props.info['title']}</h5>
                    <p class="subheading card-text">{this.props.info['text']}</p>
<p class="subheading card-text">{this.props.info['text1']}</p>
<p class="subheading card-text">{this.props.info['text2']}</p>
<p class="subheading card-text">{this.props.info['text3']}</p>
<p class="subheading card-text">{this.props.info['text4']}</p>
<p class="subheading card-text">{this.props.info['text5']}</p>
<p class="subheading card-text">{this.props.info['text6']}</p>
<p class="subheading card-text">{this.props.info['text7']}</p>
<p class="subheading card-text">{this.props.info['text8']}</p>
<p class="subheading card-text">{this.props.info['text9']}</p>
<p class="subheading card-text">{this.props.info['text10']}</p>
<p class="subheading card-text">{this.props.info['text11']}</p>
<p class="subheading card-text">{this.props.info['text12']}</p>
<p class="subheading card-text">{this.props.info['text13']}</p>
<p class="subheading card-text">{this.props.info['text14']}</p>
<p class="subheading card-text">{this.props.info['text15']}</p>
<p class="subheading card-text">{this.props.info['text16']}</p>
<p class="subheading card-text">{this.props.info['text17']}</p>
<p class="subheading card-text">{this.props.info['text18']}</p>
<p class="subheading card-text">{this.props.info['text19']}</p>
<p class="subheading card-text">{this.props.info['text20']}</p>
                </div>
            </div>
        );
    }
}
 
